enum ProductType {
  ASS_BRPT = 'ASS_BRPT',
  ADV_RPT = 'ADV_RPT',
  ASS_ARPT = 'ASS_ARPT',
}

enum PriceKeyMap {
  ASS_BRPT = 'assessmentPrice',
  ADV_RPT = 'advancedReportPrice',
  ASS_ARPT = 'assessmentWithAdvancedReportPrice',
}

enum CheckoutType {
  // TEACHER_ASSESSMENT = 'TEACHER_ASSESSMENT',
  // TEACHER_REPORT = 'TEACHER_REPORT',
  INSTITUTE_BULK_ASSESSMENT = 'INSTITUTE_BULK_ASSESSMENT',
  STUDENT_ASSESSMENT = 'STUDENT_ASSESSMENT',
  STUDENT_REPORT = 'STUDENT_REPORT',
}

enum OtpType {
  // TEACHER_REGISTER = 'teacher_register',
  // TEACHER_LOGIN = 'teacher_login', 
  // INSTITUTE_REGISTER = 'institute_register',
  // POC_INSTITUTE_REGISTER = 'poc_institute_register',
  // INSTITUTE_LOGIN = 'institute_login',
  STUDENT_LOGIN = 'student_login',
  STUDENT_REGISTER = 'student_register',
  STUDENT_FORGET_PASSWORD = 'student_forget_password',
}

enum BuyAssessmentAction {
  BUY_NOW = 'buy_now',
  ADD_TO_CART = 'add_to_cart'
}

enum AssessmentAttributes {
  REPORT = 'report',
  LEVELS_SUBJECTS = 'levels_subjects',
  PROFICIENCY_LEVEL = 'proficiency_level',
  LEVELS = 'levels'
}

enum PaymentStatus {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
}

enum HighestQualificationEnum {
  BACHELORS = 'Bachelors',
  MASTERS = 'Masters',
  DOCTORATE = 'Doctorate',
  POST_DOCTORATE = 'Post-Doctorate',
}

enum AssessmentReportType {
  BASIC = 'BASIC',
  ADVANCED = 'ADVANCED',
}

enum AssessmentSlug {
  EPA = "educator-proficiency-assessment",
  CS = "communication-skills",
  DL = "digital-literacy",
}

enum StudentLoginQueryParamEnum {
  OTP = "otp",
  PASSWORD = "password",
}

enum FormStatus {
  VALID = "VALID",
  INVALID = "INVALID",
}

enum AssessmentButtonEnum {
  BUY_ASSESSMENT = "buy_assessment",
  START_ASSESSMENT = "start_assessment",
  VIEW_RESULT = "view_result",
}

enum ReportTypeEnum {
  BASIC_REPORT = "Basic Report",
  ADVANCED_REPORT = "Advanced Report",
}

enum AssessmentTabsEnum {
  MY_ASSESSMENTS = 'my-assessments',
  MY_OLYMPIADS = 'my-olympiads',
  MY_LEARNINGS = 'my-learnings'
}

enum AssessmentStatusEnum {
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
}

export {
  PriceKeyMap,
  ProductType,
  CheckoutType,
  OtpType,
  BuyAssessmentAction,
  AssessmentAttributes,
  PaymentStatus,
  HighestQualificationEnum,
  AssessmentReportType,
  AssessmentSlug,
  StudentLoginQueryParamEnum,
  FormStatus,
  AssessmentButtonEnum,
  ReportTypeEnum,
  AssessmentTabsEnum,
  AssessmentStatusEnum,
}